// The Style Hub guide (23_SPHub.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'The three tabs',
  tabsB: 'Connections shows whether the data sources answer and when the ledgers last changed. Style lists the SKUs with their season and details; Material lists the materials.',
  connT: 'Is each source reachable',
  connB: 'One card per source (SAP, NetSuite and so on) with how long it took to answer. A card that says not configured means that server holds no credentials for it.',
  refreshT: 'When the data last changed',
  refreshB: 'One row per ledger: how many rows it holds, when it last loaded successfully and any problem since. Most people come here for this table.',
  btnsT: 'Refresh now',
  btnsB: 'Check again re-reads the status. If you have the right, the SAP and NetSuite buttons reload that source immediately instead of waiting for the scheduled run.',
};
const ko = {
  tabsT: '세 개의 탭',
  tabsB: 'Connections는 데이터 소스 응답 여부와 원장이 마지막으로 바뀐 시점을 보여 줍니다. Style은 SKU와 시즌·상세를, Material은 자재를 보여 줍니다.',
  connT: '소스에 연결되는지',
  connB: '소스(SAP, NetSuite 등)마다 카드가 있고 응답 시간이 표시됩니다. not configured라고 나오면 이 서버에 해당 인증 정보가 없다는 뜻입니다.',
  refreshT: '데이터가 마지막으로 바뀐 때',
  refreshB: '원장별로 행 수, 마지막 성공 적재 시점, 그 이후 문제를 보여 줍니다. 대부분 이 표를 보러 오십니다.',
  btnsT: '지금 새로고침',
  btnsB: 'Check again은 상태를 다시 읽습니다. 권한이 있으면 SAP와 NetSuite 버튼으로 예약 실행을 기다리지 않고 바로 해당 소스를 다시 불러올 수 있습니다.',
};
const vi = {
  tabsT: 'Ba tab',
  tabsB: 'Connections cho biết các nguồn dữ liệu có phản hồi không và ledger đổi lần cuối khi nào. Style liệt kê SKU kèm mùa và chi tiết; Material liệt kê nguyên phụ liệu.',
  connT: 'Từng nguồn có kết nối được không',
  connB: 'Mỗi nguồn (SAP, NetSuite…) một thẻ, kèm thời gian phản hồi. Thẻ ghi not configured nghĩa là server này không giữ credential của nguồn đó.',
  refreshT: 'Dữ liệu đổi lần cuối khi nào',
  refreshB: 'Mỗi ledger một dòng: số dòng hiện có, lần tải thành công gần nhất và lỗi nếu có từ đó đến nay. Phần lớn mọi người vào đây để xem bảng này.',
  btnsT: 'Làm mới ngay',
  btnsB: 'Check again đọc lại trạng thái. Nếu bạn có quyền, nút SAP và NetSuite tải lại nguồn đó ngay, không phải đợi lượt chạy theo lịch.',
};
const zh = {
  tabsT: '三个标签页',
  tabsB: 'Connections 显示数据源是否有响应以及 ledger 最近一次变化的时间。Style 列出 SKU 及其季节和详情；Material 列出物料。',
  connT: '各数据源能否连通',
  connB: '每个数据源（SAP、NetSuite 等）一张卡片，并显示响应时间。显示 not configured 表示本服务器没有该数据源的凭据。',
  refreshT: '数据最近一次变化',
  refreshB: '每个 ledger 一行：行数、最近一次成功加载的时间，以及之后出现的问题。大多数人来这里就是看这张表。',
  btnsT: '立即刷新',
  btnsB: 'Check again 会重新读取状态。如果你有权限，SAP 和 NetSuite 按钮会立即重新加载该数据源，无需等待定时任务。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Les trois onglets",
  "tabsB": "Connexions indique si les sources de données répondent et quand les registres ont changé pour la dernière fois. Style liste les SKU avec leur saison et leurs détails ; Material liste les matières.",
  "connT": "Chaque source est-elle joignable",
  "connB": "Une carte par source (SAP, NetSuite, etc.) avec son temps de réponse. Une carte indiquant not configured signifie que ce serveur ne détient aucun identifiant pour elle.",
  "refreshT": "Quand les données ont changé pour la dernière fois",
  "refreshB": "Une ligne par registre : combien de lignes il contient, quand il a été chargé avec succès pour la dernière fois et tout problème depuis. La plupart des gens viennent ici pour ce tableau.",
  "btnsT": "Actualiser maintenant",
  "btnsB": "Vérifier à nouveau relit l'état. Si vous en avez le droit, les boutons SAP et NetSuite rechargent immédiatement cette source au lieu d'attendre l'exécution planifiée."
};
const ja = {
  "tabsT": "3つのタブ",
  "tabsB": "「接続」はデータソースが応答しているか、台帳が最後にいつ更新されたかを表示します。Style は SKU をシーズンや詳細とともに、Material は資材を一覧表示します。",
  "connT": "各ソースに接続できるか",
  "connB": "ソース（SAP、NetSuite など）ごとに1枚のカードで、応答にかかった時間を表示します。not configured と表示されたカードは、そのサーバーにそのソースの認証情報がないことを意味します。",
  "refreshT": "データの最終更新",
  "refreshB": "台帳ごとに1行で、保持している行数、最後に正常に読み込まれた日時、その後の問題を表示します。多くの方は、この表を見るためにここに来ます。",
  "btnsT": "今すぐ更新",
  "btnsB": "「再確認」でステータスを読み直します。権限がある場合、SAP と NetSuite のボタンは、定期実行を待たずにそのソースをすぐに再読み込みします。"
};

const dictionary = { ns: 'tourSpHub', en, ko, vi, zh, fr, ja };
export default dictionary;
